/**
 * Formats a Date object as a string in DDMMYYYY format.
 *
 * @example
 * formatDateDDMMYYYY(new Date("2025-12-17")) // "17122025"
 *
 * @param date - The date to format. Defaults to the current date.
 * @returns A string representing the date in DDMMYYYY format.
 */
export function formatDateDDMMYYYY(date: Date = new Date()): string {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();

  return `${day}${month}${year}`;
}
